/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, setLanguage} from '../../../i18n/Metronici18n'

const languages = [
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'fr',
    name: 'French',
    flag: toAbsoluteUrl('/media/flags/france.svg'),
  },
]

const Languages: FC = () => {
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)
  return (
      <div className='d-flex mb-10'>
          {languages.map((l) => (
              <a href='#'
                 key={l.lang}
                 onClick={() => {
                   setLanguage(l.lang)
                 }}
                 className={l.lang === currentLanguage?.lang ? 'rounded bg-light px-3 py-2':'rounded px-3 py-2'}>
                <span className='symbol symbol-20px me-4'>
                  <img className='rounded-1' src={l.flag} alt='flag' />
                </span>
                    {l.name}
              </a>
          ))}
      </div>
  )
}

export {Languages}
